module.exports = __webpack_public_path__ + "img/step4-3.4314cd55.png";